import { configureStore } from "@reduxjs/toolkit";
import pageDetail from "./reducers/pageDetail";
import refresh from "./reducers/refresh";
import account from "./reducers/account";
import stocks from "./reducers/stocks";
import market from "./reducers/market";
import storage from "redux-persist/lib/storage";
import { persistReducer, FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER } from "redux-persist";
import { combineReducers } from "@reduxjs/toolkit";

const persistConfig = {
  key: "root",
  version: 1,
  storage,
  // Live data: always fetched fresh, never written to localStorage.
  blacklist: ["stocks", "market"],
};

const reducer = combineReducers({
  page: pageDetail,
  refresh: refresh,
  account: account,
  stocks: stocks,
  market: market,
});

const persistedReducer = persistReducer(persistConfig, reducer)

// Create the Redux store
const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }),
});

export default store;
